import { useEffect, useState } from 'react';

export type TextareaProps = {
  identifier?: any;
  initialValue?: string;
  onChange: (value: string) => void | Promise<void>;
  placeholder?: string;
  className?: string;
};

const Textarea = (props: TextareaProps) => {
  const [value, setValue] = useState<string>('');
  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(event.target.value);
    props.onChange(event.target.value);
  };

  useEffect(() => {
    setValue(props.initialValue || '');
  }, [props.identifier]);

  return <textarea
    value={value}
    onChange={onChange}
    placeholder={props.placeholder}
    className={props.className}
  />;
};

export default Textarea;
